__turbopack_context__.v({
  "flat": "Button-module__LCT47W__flat",
  "loading": "Button-module__LCT47W__loading",
  "navbar": "Button-module__LCT47W__navbar",
  "outline": "Button-module__LCT47W__outline",
  "primary": "Button-module__LCT47W__primary",
  "root": "Button-module__LCT47W__root",
  "slim": "Button-module__LCT47W__slim",
});
